export default __webpack_public_path__ + "static/media/dooh_optimized.6f0ece30.svg";